<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="800">
    <v-form ref="form" class="white px-11 py-10">
      <v-row class="pb-9">
        <v-col cols="11">
          <p class="form__title mb-0 gray--text">
            INSERIR COSSEGURO
          </p>
        </v-col>
        <v-col cols="1" class="text-end pb-5">
          <BaseButton text icon @click="closeModal" class="justify-end">
            <v-icon size="17" color="gray" class="justify-end">
              fa-times
            </v-icon>
          </BaseButton>
        </v-col>
        <v-col cols="12" sm="6" class="pr-sm-5">
          <BaseFormAutocomplete
            id-element="insuranceModal"
            placeholder="Selecione"
            v-model="form.seguradora"
            label-text="Seguradora"
            :items="currentSelectFilterQuotation"
            required
            validate-on-blur
            :rules="[requiredInput]"
            item-text="nome"
            item-value="id"
            :return-object="true"
          />
        </v-col>
        <v-col cols="12" sm="5" class="pr-sm-5">
          <BaseFormInput
            id-element="participationModal"
            placeholder="Digite"
            v-model="form.participacao"
            label-text="Participação"
            required
            validate-on-blur
            :rules="[requiredInput, maxShare]"
            type="number"
          />
        </v-col>
        <v-col cols="12" sm="1" class="pb-5 pb-sm-0 pt-sm-8">
          <BaseButton
            @click="newItem"
            class="secondary px-0 button-modal-co-insurance"
          >
            <v-icon size="20">
              fa-plus
            </v-icon>
          </BaseButton>
        </v-col>
        <v-col cols="12">
          <v-divider />
        </v-col>
      </v-row>
      <v-row class="pb-8">
        <v-col cols="12">
          <BaseDataTable
            v-if="hasItems"
            :headers="header"
            :items="listItems"
            hide-default-footer
          >
            <template v-slot:[`item.participacao`]="{ item }">
              {{ item.participacao }}%
            </template>
            <template v-slot:[`item.seguradora`]="{ item }">
              <BaseButton
                color="secondary"
                class="button-delete-insurance px-0"
                @click="deleteItem(item)"
                :disabled="isLeaderInsurance(item)"
              >
                <img src="@/assets/ic_trash.svg" alt="Excluir seguradora" />
              </BaseButton>
            </template>
          </BaseDataTable>
          <BaseErrorMessages
            v-if="errorMessages.length > 0"
            :error-messages="errorMessages"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="3">
          <BaseButton
            @click="submit"
            class="secondary"
            width="100%"
            v-html="'CONCLUIR'"
            :disabled="!totalSharesIs100"
          />
        </v-col>
      </v-row>
    </v-form>
  </v-dialog>
</template>
<script>
const tableHeaders = [
  { text: "Seguradora", value: "seguradora.nome", sortable: false },
  { text: "Participação (%)", value: "participacao", sortable: false },
  { text: "Ações", value: "seguradora", sortable: false }
];
import { requiredInput } from "@/utils/rules.js";
import _ from "lodash";
import { mapActions, mapState } from "vuex";
export default {
  data: () => ({
    form: {},
    requiredInput,
    header: tableHeaders,
    listItems: [],
    errorMessages: []
  }),
  created() {
    this.listItems = _.cloneDeep(this.items);
    this.checkFormSuggest();
  },
  computed: {
    ...mapState("quotation", ["currentSelectFilterQuotation"]),
    hasItems() {
      return this.listItems.length > 0;
    },
    totalSharesIs100() {
      return (
        this.listItems.reduce(
          (acc, currentValue) => acc + parseFloat(currentValue.participacao),
          0
        ) === 100
      );
    }
  },
  methods: {
    ...mapActions("quotation", ["updateSelectFilterQuotation"]),
    newItem() {
      const newItem = _.cloneDeep(this.updateNewItem());
      if (this.$refs.form.validate()) {
        if (
          !this.listItems.some(
            item => item.seguradora.id === newItem.seguradora.id
          )
        ) {
          if (this.checkTotalShares(newItem, { deleting: false })) {
            this.listItems.push(newItem);
            this.form = {};
          }
        } else {
          this.errorMessages = [
            `A seguradora ${
              this.updateNewItem().seguradora.nome
            } já está na lista`
          ];
        }
      }
    },
    closeModal() {
      this.$emit("close");
    },
    updateNewItem() {
      // Preciso colocar elementos novos como objeto
      if (_.isString(this.form.seguradora)) {
        this.form.seguradora = { nome: this.form.seguradora };
        this.updateSelectFilterQuotation(this.form.seguradora);
      }
      return this.form;
    },
    submit() {
      this.$emit("submit", this.listItems);
    },
    deleteItem(item) {
      const index = this.listItems.indexOf(item);
      this.listItems.splice(index, 1);
      this.checkTotalShares(item, { deleting: true });
    },
    checkTotalShares(item, { deleting }) {
      const leaderInsurance = this.listItems.find(
        e => e.seguradora.id === this.policyInsurance.id
      );
      if (deleting) {
        leaderInsurance.participacao -= -item.participacao;
      } else {
        if (leaderInsurance.participacao - item.participacao > 0) {
          leaderInsurance.participacao -= item.participacao;
        } else {
          this.errorMessages = [
            "Participação da seguradora líder não pode ser 0%"
          ];
          return false;
        }
      }
      const totalShares = this.listItems.reduce(
        (acc, currentValue) => acc + parseFloat(currentValue.participacao),
        parseFloat(!deleting ? item.participacao : 0)
      );
      this.errorMessages =
        this.listItems.length > 0 && totalShares !== 100
          ? ["Valor total das participações deve ser 100%"]
          : [];
      return totalShares <= 100;
    },
    checkFormSuggest() {
      if (this.listItems.length === 0 && this.policyInsurance) {
        this.listItems.push({
          seguradora: this.policyInsurance,
          participacao: "100"
        });
      }
    },
    maxShare(value) {
      return value <= 100 || "Valor deve ser menor que 100%";
    },
    isLeaderInsurance(item) {
      return item.seguradora.id === this.policyInsurance.id;
    }
  },
  props: {
    items: {
      type: Array
    },
    policyInsurance: {
      type: Object
    }
  },
  watch: {
    policyInsurance(value) {
      this.form = {
        seguradora: value,
        participacao: "100"
      };
    }
  }
};
</script>
<style lang="sass">
.button-modal-co-insurance
  min-width: 100% !important
.button-delete-insurance
  min-width: 40px !important
</style>
